import { HelmetDexteel } from "@dexteel/mesf-core";
import { CobblesReport } from "./components/CobblesReport";

export const CobblesReportPage = () => {
	return (
		<>
			<HelmetDexteel title="Cobbles Report" />
			<CobblesReport />
		</>
	);
};
